import { render, staticRenderFns } from "./otherCourse.vue?vue&type=template&id=25c89819&scoped=true"
import script from "./otherCourse.vue?vue&type=script&lang=js"
export * from "./otherCourse.vue?vue&type=script&lang=js"
import style0 from "./otherCourse.vue?vue&type=style&index=0&id=25c89819&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25c89819",
  null
  
)

export default component.exports